import {
  FETCH_WORKKARD_DETAIL_MASTER_DATA,
  UPDATE_WORKKARD_FIELD,
  FETCH_WORKKARD_CARRIER,
  ACTIVITY_LISTING_DATA,
  ACTIVITY_NOTE_TEMPLATES,
  ACTIVITY_WATCHER_LIST,
  WORKKARD_WATCHER_LIST,
  FETCH_ASSOCIATED_WARKKARD_DATA,
  FETCH_ACTIVITY_DETAIL_DATA,
  FETCH_ACTIVITY_TEMPLATES_LIST,
  FETCH_ASSOCIATED_WARKKARD_FILTER,
  // GET_ALL_NOTE_TEMPLATES,
  GET_SELECTED_NOTE_TEMPLATE_DATA,
  GET_ALL_DRAFT_NOTES,
  // FETCH_MIDDLE_PANEL_NOTES_SUCCESS,
  // FETCH_MIDDLE_PANEL_WORKKARD_NOTES_SUCCESS,
  FETCH_MIDDLE_PANEL_DIARIES_SUCCESS,
  FETCH_MIDDLE_PANEL_LOG_SUCCESS,
  FETCH_MIDDLE_PANEL_FILE_SUCCESS,
  FETCH_MIDDLE_PANEL_PARTIES_SUCCESS,
  FETCH_MIDDLE_PANEL_WORKKARD_FILE_SUCCESS,
  FETCH_MIDDLE_PANEL_WORKKARD_LOG_SUCCESS,
  FETCH_MIDDLE_PANEL_WORKKARD_DIARIES_SUCCESS,
  PUBLISH_SAVED_NOTE, DELETE_SAVED_NOTE_REQUEST,
  DELETE_SAVED_WORKKARD_NOTE_REQUEST,
  PUBLISH_SAVED_NOTE_INTERNAL, CHANGE_NOTE_TYPE,
  CHANGE_NOTE_CREATION_ACTIVITY_TEMPLATE_REQUEST,
  WORKKARD_TODO_OWNERS_SUCCESS,
  DIARIES_TITLE_EDIT_SUCCESS,
  DIARIES_DUE_DATE_EDIT_SUCCESS,
  DIARIES_ACTION_COMPLETE_SUCCESS,
  DIARIES_ACTION_CANCELLED_SUCCESS,
  SAVE_AND_UPDATE_FILE_CAPTION,
  FETCH_WORKKARD_LETTER_REQUEST,
  GET_COMBINED_VIEW_ACTIVITY_SUCCESS,
  GET_COMBINED_VIEW_FILTER_SUCCESS,
  GET_COMBINED_VIEW_SETTING_SUCCESS,
  GET_COMBINE_VIEW_ALL_DATA_SUCCESS,
  FETCH_COMBINED_VIEW_WORKKARD_FILES_SUCCESS,
  BULK_COMPLETE_OPEN_DIERIES_REQUEST,
  CHANGE_ACTIVITY_UPDATE_STATUS_REQUEST,
  CLOSE_WORKKARD_BULK_COMPLETE_OPEN_DIERIES_REQUEST,
  BULK_COMPLETE_OPEN_ACTIVITIES_REQUEST,
  CLOSE_WORKKARD_REQUEST,
  GET_CLOSE_WORKKARD_PERMISSION,
  GET_ALL_DRAFTS_COUNT,
  SET_USER_TOUR_STATUS,
  GET_USER_TOUR_STATUS,
  UPDATE_ACTIVITY_FIELD,
  PUBLISH_SAVED_NOTE_WORKKARD,
  SETTINGS_FILTER_SUCCESS,
  PUBLISH_SAVED_NOTE_INTERNAL_WORKKARD,
  DELETE_ASSOCIATED_PARTY_REQUEST,
  FETCH_PRINT_COMBINED_VIEW_DATA_REQUEST,
  FETCH_REOPEN_REASON_LIST,
  FETCH_CONTACT_INSURED_DETAILS_REQUEST,
  SAVE_CONTACT_INSURED_DETAILS,
  GET_TIMEZONE_BY_ZIP,
  GET_CLOSE_ACT_PERMISSION,
  UPDATE_USER_CUSTOM_FIELD_DATA,
  RESET_USER_CUSTOM_FIELD_DATA,
  UPDATE_USER_PINNED_FIELDS
} from "../../containers/WorkkardDetail/actions/actionConstants";

import { CHANGE_ACTIVITY_REASSIGN_SUCCESS, GET_REASSIGN_ACTIVITY_REQUEST } from '../../components/ChangeAssignee/actionConstants';

import AppConstants from "../../config/appConstants";

const mappingObject= {};

mappingObject[FETCH_WORKKARD_DETAIL_MASTER_DATA] = {
  url: "/getwkinfoapi?cId=",
  mockdata: "workkard.json",
  type: "file",
  method: AppConstants.httpMethod.GET
};

mappingObject[ACTIVITY_LISTING_DATA] = {
  url: "/getactbyclmapi",
  mockdata: "workkardActivitylisting.json",
  type: "file",
  method: AppConstants.httpMethod.GET
};

mappingObject[ACTIVITY_NOTE_TEMPLATES] = {
  url: "/getactnotetemplates",
  mockdata: "workkardActivitylisting.json",
  type: "file",
  method: AppConstants.httpMethod.GET,
};

mappingObject[ACTIVITY_WATCHER_LIST] = {
  url: "/wtactsubuslst",
  mockdata: "activitywatcher.json",
  type: "file",
  method: AppConstants.httpMethod.GET
};

mappingObject[WORKKARD_WATCHER_LIST] = {
  url: "/wtclmsubuslst",
  mockdata: "workkardwatcher.json",
  type: "file",
  method: AppConstants.httpMethod.GET
};

mappingObject[FETCH_ASSOCIATED_WARKKARD_DATA] = {
  url: "/getassociatedWkds",
  mockdata: "associatedWorkkard.json",
  type: "file",
  method: AppConstants.httpMethod.GET
};

mappingObject[FETCH_ASSOCIATED_WARKKARD_FILTER] = {
  url: "/fetchFilters",
  mockdata: "associatedWorkkardFilter.json",
  type: "file",
  method: AppConstants.httpMethod.GET
};

mappingObject[FETCH_ACTIVITY_DETAIL_DATA] = {
  url: "/1.0/gadapi",
  mockdata: "activityDetail.json",
  type: "file",
  method: AppConstants.httpMethod.GET
};

mappingObject[UPDATE_ACTIVITY_FIELD] = {
  url: "/updateactfield",
  mockdata: "activityUpdateField.json",
  type: "file",
  method: AppConstants.httpMethod.POST
};

mappingObject[CHANGE_ACTIVITY_REASSIGN_SUCCESS] = {
  url: "/reaioactapi",
  mockdata: "reassignActivity.json",
  type: "file",
  method: AppConstants.httpMethod.POST
};

mappingObject[UPDATE_WORKKARD_FIELD] = {
  url: "/updatewrkkdfield",
  mockdata: "updateWorkkardField.json",
  type: "file",
  method: AppConstants.httpMethod.POST 
};

mappingObject[FETCH_WORKKARD_CARRIER] = {
  url: "/wkcarrier",
  mockdata: "wkcarrier.json",
  type: "file",
  method: AppConstants.httpMethod.GET
};

mappingObject[FETCH_ACTIVITY_TEMPLATES_LIST] = {
  url: "/gat",
  mockdata: "chooseActivityTemplate.json",
  type: "file",
  method: AppConstants.httpMethod.GET
};

// mappingObject[GET_ALL_NOTE_TEMPLATES] = {
//   url: "/1.0/note/templates",
//   mockdata: "noteTemplates.json",
//   type: "file",
//   method: AppConstants.httpMethod.GET
// };

mappingObject[GET_ALL_DRAFTS_COUNT] = {
  url: "/galldc",
  mockdata: "draftNotes.json",
  type: "file",
  method: AppConstants.httpMethod.GET
};

// mappingObject[GET_SELECTED_NOTE_TEMPLATE_DATA] = {
//   url: "/credr",
//   mockdata: "selectedNoteTemplate.json",
//   type: "file",
//   method: AppConstants.httpMethod.GET
// };

mappingObject[GET_ALL_DRAFT_NOTES] = {
  url: "/galld",
  mockdata: "alldraftnotes.json",
  type: "file",
  method: AppConstants.httpMethod.GET
};

// mappingObject[FETCH_MIDDLE_PANEL_NOTES_SUCCESS] = {
//   url: "/1.0/getactnotes",
//   mockdata: "getactnotes.json",
//   type: "file",
//   method: AppConstants.httpMethod.GET
// };

// mappingObject[FETCH_MIDDLE_PANEL_WORKKARD_NOTES_SUCCESS] = {
//   url: "/1.0/getwknotes",
//   mockdata: "getwknotes.json",
//   type: "file",
//   method: AppConstants.httpMethod.GET
// };

mappingObject[FETCH_MIDDLE_PANEL_WORKKARD_FILE_SUCCESS] = {
  url: "/1.0/getclmfiles",
  mockdata: "getclmfiles.json",
  type: "file",
  method: AppConstants.httpMethod.GET
};

mappingObject[FETCH_MIDDLE_PANEL_FILE_SUCCESS] = {
  url: "/1.0/getclmfiles",
  mockdata: "files.json",
  type: "file",
  method: AppConstants.httpMethod.GET
};

mappingObject[FETCH_MIDDLE_PANEL_LOG_SUCCESS] = {
  url: "/1.0/getactlogs",
  mockdata: "log.json",
  type: "file",
  method: AppConstants.httpMethod.GET
};

mappingObject[FETCH_MIDDLE_PANEL_WORKKARD_LOG_SUCCESS] = {
  url: "/1.0/getworklogs",
  mockdata: "getworklogs.json",
  type: "file",
  method: AppConstants.httpMethod.GET
};

mappingObject[FETCH_MIDDLE_PANEL_DIARIES_SUCCESS] = {
  url: "/acttdo",
  mockdata: "diaries.json",
  type: "file",
  method: AppConstants.httpMethod.GET
};

mappingObject[FETCH_MIDDLE_PANEL_WORKKARD_DIARIES_SUCCESS] = {
  url: "/1.0/clmtodo",
  mockdata: "wrktdo.json",
  type: "file",
  method: AppConstants.httpMethod.GET
};

mappingObject[WORKKARD_TODO_OWNERS_SUCCESS] = {
  url: "/wrkowntodo",
  mockdata: "wrkowntodo.json",
  type: "file",
  method: AppConstants.httpMethod.GET
};


mappingObject[FETCH_MIDDLE_PANEL_PARTIES_SUCCESS] = {
  url: "/getpartiesinvlv",
  mockdata: "parties.json",
  type: "file",
  method: AppConstants.httpMethod.GET
};

mappingObject[PUBLISH_SAVED_NOTE] = {
  url: "/pubactntpub",
  mockdata: "publishNote.json",
  type: "file",
  method: AppConstants.httpMethod.GET
}

mappingObject[PUBLISH_SAVED_NOTE_WORKKARD] = {
  url: "/pubclmntpub",
  mockdata: "publishNote.json",
  type: "file",
  method: AppConstants.httpMethod.GET
}

mappingObject[PUBLISH_SAVED_NOTE_INTERNAL_WORKKARD] = {
  url: "/pubclmntpvt",
  mockdata: "publishNote.json",
  type: "file",
  method: AppConstants.httpMethod.GET
}

mappingObject[PUBLISH_SAVED_NOTE_INTERNAL] = {
  url: "/pubactntpvt",
  mockdata: "publishNote.json",
  type: "file",
  method: AppConstants.httpMethod.GET
}

mappingObject[DELETE_SAVED_NOTE_REQUEST] = {
  url: "/delactnt",
  mockdata: "deleteNote.json",
  type: "file",
  method: AppConstants.httpMethod.GET
}

mappingObject[DELETE_SAVED_WORKKARD_NOTE_REQUEST] = {
  url: "/delclmnt",
  mockdata: "deleteNote.json",
  type: "file",
  method: AppConstants.httpMethod.GET
}

mappingObject[CHANGE_NOTE_TYPE] = {
  url: "/gntbnt",
  mockdata: "changeNoteTemplate.json",
  type: "file",
  method: AppConstants.httpMethod.GET
}

mappingObject[CHANGE_NOTE_CREATION_ACTIVITY_TEMPLATE_REQUEST] = {
  url: "/gactnotesdata",
  mockdata: "changeNoteActivityTemplate.json",
  type: "file",
  method: AppConstants.httpMethod.GET
}
mappingObject[DIARIES_TITLE_EDIT_SUCCESS] = {
  url: "/uptitletodo",
  mockdata: "uptitletodo.json",
  type: "file",
  method: AppConstants.httpMethod.POST
}

mappingObject[DIARIES_DUE_DATE_EDIT_SUCCESS] = {
  url: "/upduedatetodo",
  mockdata: "upduedatetodo.json",
  type: "file",
  method: AppConstants.httpMethod.POST
}

mappingObject[DIARIES_ACTION_COMPLETE_SUCCESS] = {
  url: "/TodoAction/CompleteTodo",
  mockdata: "CompleteTodo.json",
  type: "file",
  method: AppConstants.httpMethod.POST
}

mappingObject[DIARIES_ACTION_CANCELLED_SUCCESS] = {
  url: "/tododel",
  mockdata: "tododel.json",
  type: "file",
  method: AppConstants.httpMethod.POST
}


mappingObject[SAVE_AND_UPDATE_FILE_CAPTION] = {
  url: "/asavedn",
  mockdata: "updateDirayNote.json",
  type: "file",
  method: AppConstants.httpMethod.POST
}

mappingObject[FETCH_WORKKARD_LETTER_REQUEST] = {
  url: "/gateway/logs",
  mockdata: "getwrklettersreference.json",
  type: "file",
  method: AppConstants.httpMethod.GET
}

mappingObject[GET_COMBINED_VIEW_ACTIVITY_SUCCESS] = {
  url: "/cvfat",
  mockdata: "combinedViewcvfat.json",
  type: "file",
  method: AppConstants.httpMethod.GET
}

mappingObject[GET_COMBINED_VIEW_FILTER_SUCCESS] = {
  url: "/cvfu",
  mockdata: "combinedViewcvfu.json",
  type: "file",
  method: AppConstants.httpMethod.GET
}

mappingObject[GET_COMBINED_VIEW_SETTING_SUCCESS] = {
  url: "/cvgs",
  mockdata: "combinedViewcvgs.json",
  type: "file",
  method: AppConstants.httpMethod.GET
}

mappingObject[SETTINGS_FILTER_SUCCESS] = {
  url: "/cvs",
  mockdata: "combinedViewcvs.json",
  type: "file",
  method: AppConstants.httpMethod.POST
}

mappingObject[GET_COMBINE_VIEW_ALL_DATA_SUCCESS] = {
  url: "/cvp",
  mockdata: "combinedViewcvp.json",
  type: "file",
  method: AppConstants.httpMethod.GET
}

mappingObject[FETCH_COMBINED_VIEW_WORKKARD_FILES_SUCCESS] = {
  url: "/1.0/getwkfiles",
  mockdata: "getwkfiles.json",
  type: "file",
  method: AppConstants.httpMethod.GET
}

// /cvf, /cvncf, /cvl and /cvu are retired: the /cvp page now embeds
// attachments, note custom fields and field changes, and actor names resolve
// from the shared user store rather than a per-page profile lookup.

mappingObject[BULK_COMPLETE_OPEN_DIERIES_REQUEST] = {
  url: '/blkcmpopdiary',
  mockdata: 'updatepagesize.json',
  method: AppConstants.httpMethod.POST
}

mappingObject[BULK_COMPLETE_OPEN_ACTIVITIES_REQUEST] = {
  url: '/clsactblkweb',
  mockdata: 'updatepagesize.json',
  method: AppConstants.httpMethod.POST
}

mappingObject[CLOSE_WORKKARD_BULK_COMPLETE_OPEN_DIERIES_REQUEST] = {
  url: '/comptodoblkweb',
  mockdata: 'updatepagesize.json',
  method: AppConstants.httpMethod.POST
}

mappingObject[CHANGE_ACTIVITY_UPDATE_STATUS_REQUEST] = {
  url: '/activityupdate/changeactivityupdatestatus',
  mockdata: 'updatepagesize.json',
  method: AppConstants.httpMethod.POST
}

mappingObject[CLOSE_WORKKARD_REQUEST] = {
  url: '/clswkkd',
  mockdata: 'updatepagesize.json',
  method: AppConstants.httpMethod.POST
}

mappingObject[GET_CLOSE_WORKKARD_PERMISSION] = {
  url: "/gclwkdpermission",
  mockdata: "workkardpermission.json",
  type: "file",
  method: AppConstants.httpMethod.GET
}

mappingObject[GET_REASSIGN_ACTIVITY_REQUEST] = {
  url: "/gractapi",
  mockdata: "",
  type: "file",
  method: AppConstants.httpMethod.GET
}

mappingObject[DELETE_ASSOCIATED_PARTY_REQUEST] = {
  url: "/delentpar",
  method: AppConstants.httpMethod.POST
}


mappingObject[SET_USER_TOUR_STATUS] = {
  url: "/updateapptourstatus",
  method: AppConstants.httpMethod.POST
}

mappingObject[GET_USER_TOUR_STATUS] = {
  url: "/getnewuserinfoapi",
  method: AppConstants.httpMethod.GET
}

mappingObject[GET_USER_TOUR_STATUS] = {
  url: "/getnewuserinfoapi",
  method: AppConstants.httpMethod.GET
}

mappingObject[FETCH_PRINT_COMBINED_VIEW_DATA_REQUEST] = {
  url: "/cvprint",
  mockdata: "combinedViewPrint.json",
  type: "file",
  method: AppConstants.httpMethod.GET
}

// mappingObject[GET_CLOSE_ACT_PERMISSION] = {
//   url: "/gclactpermission",
//   method: AppConstants.httpMethod.GET
// }

mappingObject[FETCH_REOPEN_REASON_LIST] = {
  url: "/getwkreopenreason",
  method: AppConstants.httpMethod.GET
}

mappingObject[FETCH_CONTACT_INSURED_DETAILS_REQUEST] = {
  url: "/getciinfoapi",
  method: AppConstants.httpMethod.GET
}

mappingObject[SAVE_CONTACT_INSURED_DETAILS] = {
  url: "/contactinsured",
  method: AppConstants.httpMethod.POST
}

mappingObject[GET_TIMEZONE_BY_ZIP] = {
  url: "/tzbyzip",
  method: AppConstants.httpMethod.GET
}
mappingObject[UPDATE_USER_CUSTOM_FIELD_DATA] = {
  url: "/updatecollapsiblefield",
  method: AppConstants.httpMethod.POST 
};
mappingObject[RESET_USER_CUSTOM_FIELD_DATA] = {
  url: "/resetucfdata",
  method: AppConstants.httpMethod.POST 
};

mappingObject[UPDATE_USER_PINNED_FIELDS] = {
  url: "/1.0/UpdateUserPinnedFields",
  method: AppConstants.httpMethod.POST 
};
export default mappingObject;
